<mat-accordion>
  <mat-expansion-panel expanded>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3 style="margin: 0">SyncHPC Services</h3>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div
      *ngIf="!synchpcService?.synchpcService"
      class="d-flex justify-content-center align-items-center"
      style="height: 200px"
    >
      <p style="margin: 0; font-size: 12px">No Synchpc Service Available</p>
    </div>
    <table *ngIf="synchpcService?.synchpcService" class="table table-hover">
      <thead>
        <tr class="table-list-head"
          style="
            color: White;
            background-color: var(--s-primary-color);
            height: 2rem;
          "
        >
          <th>Service Name</th>
          <th>Active</th>
          <th>Main PID</th>
          <th>Memory</th>
          <th>Service Description</th>
          <th>Health</th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-list-row" *ngFor="let service of synchpcService.synchpcService">
          <td class="color-primary">{{ service.service_name }}</td>
          <td>{{ service.active.status }}</td>
          <td>{{ service.main_pid }}</td>
          <td>{{ service.memory }}</td>
          <td>{{ service.service_desc }}</td>
          <td>
            <span *ngIf="service.error == 'false'"
              ><i
                class="bi bi-check"
                style="color: green; font-size: 1.5rem"
              ></i
            ></span>
            <span *ngIf="service.error != 'false'"
              ><i
                class="bi bi-exclamation"
                style="color: red; font-size: 1.3rem"
              ></i
            ></span>
            {{ service.error == "false" ? "Ok" : "Warning" }}
          </td>
        </tr>
      </tbody>
    </table>
  </mat-expansion-panel>
  <mat-expansion-panel
    (opened)="panelOpenState.set(true)"
    (closed)="panelOpenState.set(false)"
  >
    <mat-expansion-panel-header>
      <mat-panel-title
        ><h3 style="margin: 0">System Services</h3>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div
      *ngIf="!systemService?.services"
      class="d-flex justify-content-center align-items-center"
      style="height: 200px"
    >
      <p style="margin: 0; font-size: 12px">No System Service Available</p>
    </div>

    <div class="w-100">
      <div class="jobs">
        <table *ngIf="systemService?.services" 
            class="table table-hover table-condensed "
            cellspacing="0">
            <thead>
              <tr class="table-list-head"
                style="
                  color: White;
                  background-color: var(--s-primary-color);
                  height: 2rem;
                "
              >
                <th>Service Name</th>
                <th>Load</th>
                <th>Active</th>
                <th>Sub Status</th>
                <th>Description</th>
                <th>Health</th>
              </tr>
            </thead>

            <tbody>
              <tr class="table-list-row" *ngFor="let service of systemService.services">
                <td class="color-primary">{{ service.unit }}</td>
                <td>{{ service.load }}</td>
                <td>{{ service.active }}</td>
                <td>{{ service.sub }}</td>
                <td>{{ service.description }}</td>
                <td>
                  <span *ngIf="service.active == 'active'"
                    ><i
                      class="bi bi-check"
                      style="color: green; font-size: 1.3rem"
                    ></i
                  ></span>
                  <span *ngIf="service.active != 'active'"
                    ><i
                      class="bi bi-exclamation"
                      style="color: red; font-size: 1.5rem"
                    ></i
                  ></span>
                </td>
              </tr>
            </tbody>
        </table>
      </div>
    </div>
    <!-- <table *ngIf="systemService?.services" class="table table-hover">
      <thead>
        <tr
          style="
            color: White;
            background-color: var(--s-primary-color);
            height: 2rem;
          "
        >
          <th>Service Name</th>
          <th>Load</th>
          <th>Active</th>
          <th>Sub Status</th>
          <th>Description</th>
          <th>Health</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let service of systemService.services">
          <td class="color-primary">{{ service.unit }}</td>
          <td>{{ service.load }}</td>
          <td>{{ service.active }}</td>
          <td>{{ service.sub }}</td>
          <td>{{ service.description }}</td>
          <td>
            <span *ngIf="service.active == 'active'"
              ><i
                class="bi bi-check"
                style="color: green; font-size: 1.3rem"
              ></i
            ></span>
            <span *ngIf="service.active != 'active'"
              ><i
                class="bi bi-exclamation"
                style="color: red; font-size: 1.5rem"
              ></i
            ></span>
          </td>
        </tr>
      </tbody>
    </table> -->
  </mat-expansion-panel>
</mat-accordion>
